module.exports = __webpack_public_path__ + "static/media/me.fc548471.jpg";